import { useRouter } from 'next/router';
import G_CA from './CA';
import G_US from './US';

const G: React.FC = () => {
    const { locale = '' } = useRouter();

    return <>{locale === 'ca' ? <G_CA /> : <G_US />}</>;
};

export default G;
